import {styled} from '../../../utils';

const Main = styled('main')({
  boxSizing: 'border-box',
  display: 'block',
  flex: 1,
  flexBasis: 'auto'
});

export default Main;



// WEBPACK FOOTER //
// ./src/components/Layout/Main/Main.tsx